(function() {
  function initPackSelector() {
    const wrapper = document.querySelector('.pack-selector-wrapper');
    if (!wrapper) return;

    const packType = wrapper.dataset.packType;

    document.querySelectorAll('.product-form__input, variant-selects, variant-radios').forEach(el => el.style.display = 'none');

    const collections = {
      hombre: 'perfumes-de-hombre',
      mujer: 'perfumes-de-mujer',
      nicho: 'perfumes-nicho',
      feromonas: 'feromonas'
    };

    const nichoVariants = {
      0: '54073793020233',
      1: '54073793053001',
      2: '54073793085769',
      3: '54073793118537'
    };

    const PRECIO_NORMAL_30 = 9.95;
    const PRECIO_NICHO_30 = 12.95;
    const DESCUENTO_30 = 0.10;
    const SEDUCCION_NORMAL_TACHADO = 52.90;
    const SEDUCCION_NORMAL_OFERTA = 36.95;
    const SEDUCCION_NICHO_TACHADO = 58.90;
    const SEDUCCION_NICHO_OFERTA = 40.95;

    let targetRegular = null;
    let targetSale = null;
    let observer = null;

    function formatPrice(amount) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }

    function setPrices(regularText, saleText) {
      if (observer) observer.disconnect();
      const regularEl = document.querySelector('s.price-item.price-item--regular');
      const saleEl = document.querySelector('span.price-item.price-item--sale.price-item--last');
      if (regularEl) regularEl.textContent = regularText;
      if (saleEl) saleEl.textContent = saleText;
      targetRegular = regularText;
      targetSale = saleText;
      startObserver();
    }

    function startObserver() {
      const priceContainer = document.querySelector('.price__sale');
      if (!priceContainer) return;
      observer = new MutationObserver(() => {
        if (!targetRegular || !targetSale) return;
        const regularEl = document.querySelector('s.price-item.price-item--regular');
        const saleEl = document.querySelector('span.price-item.price-item--sale.price-item--last');
        if (regularEl && regularEl.textContent.trim() !== targetRegular) {
          observer.disconnect();
          regularEl.textContent = targetRegular;
          startObserver();
        }
        if (saleEl && saleEl.textContent.trim() !== targetSale) {
          observer.disconnect();
          saleEl.textContent = targetSale;
          startObserver();
        }
      });
      observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }

    function updatePricesPersonalizado(nichoCount) {
      const normalCount = 3 - nichoCount;
      const total = (normalCount * PRECIO_NORMAL_30) + (nichoCount * PRECIO_NICHO_30);
      const totalConDescuento = total * (1 - DESCUENTO_30);
      setPrices(formatPrice(total), formatPrice(totalConDescuento));
    }

    function updatePricesSeduccion(hasNicho) {
      if (hasNicho) {
        setPrices(formatPrice(SEDUCCION_NICHO_TACHADO), formatPrice(SEDUCCION_NICHO_OFERTA));
      } else {
        setPrices(formatPrice(SEDUCCION_NORMAL_TACHADO), formatPrice(SEDUCCION_NORMAL_OFERTA));
      }
    }

    async function fetchAllProducts(handle) {
      let all = [];
      let page = 1;
      while (true) {
        try {
          const res = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
          const data = await res.json();
          if (!data.products || data.products.length === 0) break;
          all = all.concat(data.products);
          if (data.products.length < 250) break;
          page++;
        } catch(e) { break; }
      }
      return all;
    }

    async function loadOptions(item) {
      const type = item.dataset.type;
      const input = item.querySelector('.pack-selector__input');
      const list = item.querySelector('.pack-selector__list');
      const hidden = item.querySelector('.pack-selector__hidden');
      const isNichoInput = item.querySelector('.pack-selector__is-nicho');
      const clearBtn = item.querySelector('.pack-selector__clear');
      const dot = item.querySelector('.pack-selector__dot');
      const arrow = item.querySelector('.pack-selector__arrow');

      list.innerHTML = '<li style="padding:10px;color:#999;list-style:none">Cargando...</li>';

      const suffix = packType === 'pack-seduccion' ? ' - 100ml' : ' - 30ml';
      const variantKeyword = packType === 'pack-seduccion' ? '100 ml' : '30 ml';

      let allProducts = [];

      if (type === 'feromonas') {
        const prods = await fetchAllProducts(collections.feromonas);
        allProducts = prods.map(p => ({
          title: p.title,
          variantId: p.variants[0].id,
          isNicho: false,
          genero: 'feromonas'
        }));
      } else {
        const [hombre, mujer, nicho] = await Promise.all([
          fetchAllProducts(collections.hombre),
          fetchAllProducts(collections.mujer),
          fetchAllProducts(collections.nicho)
        ]);

        const porTitulo = new Map();

        hombre.forEach(p => {
          const v = p.variants.find(v => v.title === variantKeyword) || p.variants[0];
          porTitulo.set(p.title, { title: p.title, variantId: v.id, isNicho: false, genero: 'hombre' });
        });

        mujer.forEach(p => {
          const v = p.variants.find(v => v.title === variantKeyword) || p.variants[0];
          porTitulo.set(p.title, { title: p.title, variantId: v.id, isNicho: false, genero: 'mujer' });
        });

        nicho.forEach(p => {
          const v = p.variants.find(v => v.title === variantKeyword) || p.variants[0];
          if (porTitulo.has(p.title)) {
            porTitulo.get(p.title).isNicho = true;
          } else {
            porTitulo.set(p.title, { title: p.title, variantId: v.id, isNicho: true, genero: 'nicho' });
          }
        });

        allProducts = Array.from(porTitulo.values());
      }

      allProducts.sort((a, b) => a.title.localeCompare(b.title));

      function getIcono(p) {
        if (p.genero === 'feromonas') return '🧪';
        if (p.isNicho && p.genero === 'hombre') return '💎♂';
        if (p.isNicho && p.genero === 'mujer') return '💎♀';
        if (p.isNicho) return '💎';
        if (p.genero === 'hombre') return '♂';
        if (p.genero === 'mujer') return '♀';
        return '';
      }

      function renderList(filtro) {
        list.innerHTML = '';
        const q = (filtro || '').toLowerCase();
        const filtrados = q ? allProducts.filter(p => p.title.toLowerCase().includes(q)) : allProducts;
        if (filtrados.length === 0) {
          const li = document.createElement('li');
          li.textContent = 'No se encontraron resultados';
          li.style.cssText = 'padding:10px;color:#999;list-style:none';
          list.appendChild(li);
          return;
        }
        filtrados.forEach(p => {
          const li = document.createElement('li');
          li.className = 'pack-selector__option';
          const displayText = p.genero !== 'feromonas' ? `${getIcono(p)} ${p.title}${suffix}` : `${getIcono(p)} ${p.title}`;
          li.textContent = displayText;
          if (p.isNicho) li.classList.add('pack-selector__option--nicho');
          li.addEventListener('click', () => {
            input.value = p.genero !== 'feromonas' ? `${p.title}${suffix}` : p.title;
            hidden.value = p.genero !== 'feromonas' ? `${p.title}${suffix}` : p.title;
            isNichoInput.value = p.isNicho ? 'true' : 'false';
            if (dot) dot.style.background = '#22a06b';
            if (arrow) arrow.style.display = 'none';
            clearBtn.style.display = 'inline';
            list.style.display = 'none';
            updateNichoCount();
          });
          list.appendChild(li);
        });
      }

      input.addEventListener('click', () => {
        const isOpen = list.style.display !== 'none';
        document.querySelectorAll('.pack-selector__list').forEach(l => l.style.display = 'none');
        if (!isOpen) {
          list.style.display = 'block';
          renderList(input.value);
        }
      });

      input.addEventListener('input', () => {
        list.style.display = 'block';
        renderList(input.value);
      });

      clearBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        input.value = '';
        hidden.value = '';
        isNichoInput.value = 'false';
        if (dot) dot.style.background = '';
        if (arrow) arrow.style.display = 'inline';
        clearBtn.style.display = 'none';
        list.style.display = 'none';
        updateNichoCount();
      });

      document.addEventListener('click', (e) => {
        if (!item.contains(e.target)) list.style.display = 'none';
      });
    }

    function updateNichoCount() {
      const nichoInputs = document.querySelectorAll('.pack-selector__is-nicho');
      let nichoCount = 0;
      nichoInputs.forEach(el => { if (el.value === 'true') nichoCount++; });

      if (packType === 'pack-personalizado') {
        const variantId = nichoVariants[nichoCount] || nichoVariants[0];
        const variantInput = document.querySelector('.product-variant-id');
        if (variantInput) variantInput.value = variantId;
        updatePricesPersonalizado(nichoCount);
      } else if (packType === 'pack-seduccion') {
        updatePricesSeduccion(nichoCount > 0);
      }
    }

    const items = wrapper.querySelectorAll('.pack-selector__item');
    items.forEach(item => loadOptions(item));

    if (packType === 'pack-personalizado') {
      updatePricesPersonalizado(0);
    } else if (packType === 'pack-seduccion') {
      updatePricesSeduccion(false);
    }

    const form = wrapper.closest('form.form') || wrapper.closest('form[action="/cart/add"]');
    if (form) {
      form.addEventListener('submit', (e) => {
        const hiddens = wrapper.querySelectorAll('.pack-selector__hidden');
        for (const h of hiddens) {
          if (!h.value) {
            e.preventDefault();
            e.stopPropagation();
            const label = h.closest('.pack-selector__item').querySelector('.pack-selector__label').textContent;
            alert(`Por favor elige: ${label}`);
            wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
        }
      }, true);
    }
  }

  document.addEventListener('DOMContentLoaded', initPackSelector);
})();
